module.exports = __webpack_public_path__ + "img/objects-column.7ec48d75.svg";